export default function BodyText(props) {
    return(
        <div className="font-body font-regular text-gray-light">{props.text}</div>
    )
}